// extracted by mini-css-extract-plugin
module.exports = {"host":"distributor-error_host_hz6fW","text":"distributor-error_text_2_AqI"};